import React, { useState, useRef, createElement } from 'react';
import { Header } from './components/Header';
import { RenderArea } from './components/RenderArea';
import { Sidebar, defaultParams } from './components/ControlPanel';
import { EffectParams } from './lib/effects';
import { useScreenInit } from './useScreenInit.js';
// The Magic Patterns brandmark loads by default so the studio has something
// to play with the moment it opens. Users can re-upload their own SVG anytime.
const DEFAULT_SVG = 'https://cdn.magicpatterns.com/uploads/41mFoK5vwH1zenrdvBNcDJ/brandmark-(circular).svg';
export function App() {
  const screenInit = useScreenInit();
  const [svgUrl, setSvgUrl] = useState<string | null>(screenInit?.empty ? null : DEFAULT_SVG);
  const [activeEffectId, setActiveEffectId] = useState<string>('none');
  const [effectParams, setEffectParams] = useState<EffectParams>(defaultParams);
  const processedCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const handleUpload = (file: File) => {
    const url = URL.createObjectURL(file);
    setSvgUrl(url);
    setActiveEffectId('none');
    setEffectParams(defaultParams);
  };
  const handleUploadClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.svg';
    input.onchange = (e: any) => {
      if (e.target.files && e.target.files[0]) {
        handleUpload(e.target.files[0]);
      }
    };
    input.click();
  };
  const handleExport = () => {
    if (processedCanvasRef.current) {
      const url = processedCanvasRef.current.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = 'logo-effect.png';
      a.click();
    }
  };
  return <div className="relative w-full h-screen bg-slate-100 overflow-hidden font-sans text-slate-900" data-id="element-0">
      {/* Full-bleed canvas stage sits behind the floating chrome */}
      <RenderArea svgUrl={svgUrl} activeEffectId={activeEffectId} effectParams={effectParams} onUpload={handleUpload} onProcessedCanvasReady={canvas => {
      processedCanvasRef.current = canvas;
    }} data-id="element-1" />

      <Header onUploadClick={handleUploadClick} onExportClick={handleExport} hasImage={!!svgUrl} data-id="element-2" />

      {svgUrl && <Sidebar activeEffectId={activeEffectId} onEffectChange={setActiveEffectId} params={effectParams} onParamsChange={setEffectParams} data-id="element-3" />}
    </div>;
}